import React, { Component } from 'react';
import {Subtopic, Footer,TextHolder, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterNinetyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>


        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">
            <div className="text-title-holder">
              <p>{ this.props.textTitle }</p>
            </div>
            <div className="text-holder">
              <p>In early 2018, e-commerce platform Bukalapak became
              <a href="http://www.thejakartapost.com/life/2018/01/11/bukalapak-officially-becomes-indonesias-fourth-unicorn-startup.html"> SEA’s seventh unicorn </a>
              ; it’s also the fourth unicorn based in Indonesia. Indonesia’s large consumer base offers new startups the opportunity to scale up quickly. Indonesia’s Minister of Communication and Information has <a href="https://www.reuters.com/article/us-indonesia-startups/indonesia-expects-to-have-more-than-5-unicorns-by-2019-minister-idUSKCN1G310J"> predicted </a> that his country will yield a fifth unicorn by the end of 2018. Wherever it comes from, with SEA on track to realize a <a href="https://www.blog.google/around-the-globe/google-asia/sea-internet-economy/"> $200 billion internet economy </a> by 2025, the region’s next unicorn is unlikely to be its last.</p>

            </div>
          </div>
        </div>

        <TextHolder />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/92.js